import React from "react";
import { createGlobalStyle } from "styled-components";
import "./App.css";
// Impoting the main Map Componenet
import { MapContainer } from "./components/MapContainer";

declare global {
  interface Window {
    targetStore?:string,
    competitor?: {
      locationName?: string;
      coords?: {
        lat?: number | string;
        lng: number | string;
      };
      avgRatings: number;
      placeId: string | number;
      business_type: string;
    }[],
    data?: {
      [key: string]: any;
    };
  }
}

const App = () => {

  return <MapContainer />;
};

export default App;

const GlobalStyle = createGlobalStyle`
  body {
    color: 'white';
  }
  .MuiRating-icon .fa-star{
    color: unset!important;
  }
  .MuiRating-icon.MuiRating-iconFilled {
    color: #ffb400!important;
  }
  .MuiRating-icon.MuiRating-iconEmpty {
    color: #bdbdbd!important;
  }
`;
